<template>
    <FormSearchSelect
        v-bind="$attrs"
        class="FormSelectVehicle"
        :value="value"
        :label="label"
        :options="activeVehicles"
        :reduce="vehicle => vehicle.id"
        :getOptionLabel="vehicle => vehicle.name"
        @input="handleInput"
    >
        <template v-if="showCreateOption" #list-header>
            <ButtonIcon icon="plus" class="block" @click="handleCreate">
                Add new
            </ButtonIcon>
        </template>
    </FormSearchSelect>
</template>

<script>
import VehicleCreateModal from '@/components/modals/VehicleCreateModal';

export default {
    name: 'FormSelectVehicle',
    inheritAttrs: false,

    props: {
        value: { type: Number },
        label: { type: String, default: 'Vehicle' },
        type: { type: [String, Array], default: ['trucks', 'trailers'] },
        vehicleType: { type: String },
        showCreateOption: { type: Boolean, default: false },
    },

    data: () => ({
        initialValue: null,
    }),

    computed: {
        activeVehicles() {
            const types = [this.type].flat();
            const vehicles = types.flatMap(type => this.$store.state.company[type]);

            return vehicles.filter((vehicle) => {
                return vehicle.id === this.initialValue ? true : vehicle.isActive;
            });
        },
    },

    beforeMount() {
        this.initialValue = this.value;
    },

    methods: {
        handleInput(vehicleId) {
            this.$emit('input', vehicleId);
        },

        handleCreate() {
            this.$analytics.trackButtonClick(this.$options.name, 'prompt_create_vehicle', {
                model_type: 'vehicle',
                model_action: 'create_intent',
                vehicle_type: this.vehicleType,
            });

            this.$modal.show(VehicleCreateModal, {
                onVehicleCreated: this.handleVehicleCreated,
                vehicleType: this.vehicleType,
            });
        },

        handleVehicleCreated(newVehicle) {
            this.$emit('input', newVehicle.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.FormSelectVehicle {
    .ButtonIcon {
        justify-content: flex-start;
    }
}
</style>
